// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `chart-column-comparation-component{height:100%}chart-column-comparation-component .highcharts-container{height:100% !important}`, "",{"version":3,"sources":["webpack://./src/shared/components/chart-column-comparation/chart-column-comparation.component.scss"],"names":[],"mappings":"AAAA,mCACI,WAAA,CAEA,yDACI,sBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
